import { UserManager } from 'oidc-react'
import { WebStorageStateStore } from 'oidc-client-ts'
import getEnv from '../lib/get-env.js'

const oidcConfig = {
  authority: getEnv('REACT_APP_OIDC_CONFIG_AUTHORITY'),
  clientId: getEnv('REACT_APP_OIDC_CONFIG_CLIENT_ID'),
  redirectUri:
    getEnv('REACT_APP_OIDC_CONFIG_REDIRECT_URI') ||
    `${window.location.origin}/callback`,
  silentRedirectUri: getEnv('REACT_APP_OIDC_CONFIG_SILENT_REDIRECT_URI'),
  postLogoutRedirectUri:
    getEnv('REACT_APP_OIDC_CONFIG_POST_LOGOUT_REDIRECT_URI') ||
    `${window.location.origin}/signout-callback`,
  responseType: getEnv('REACT_APP_OIDC_CONFIG_RESPONSE_TYPE') || 'code',
  scope: getEnv('REACT_APP_OIDC_CONFIG_SCOPE') || 'openid',
  extraQueryParams: getEnv('REACT_APP_OIDC_CONFIG_EXTRA_QUERY_PARAMS')
    ? JSON.parse(getEnv('REACT_APP_OIDC_CONFIG_EXTRA_QUERY_PARAMS'))
    : {
        // prompt: 'login'
      },
  loadUserInfo:
    getEnv('REACT_APP_OIDC_CONFIG_LOAD_USERINFO') &&
    getEnv('REACT_APP_OIDC_CONFIG_LOAD_USERINFO') === 'true'
      ? true
      : false,
  autoSignIn:
    getEnv('REACT_APP_OIDC_CONFIG_AUTO_SIGNIN') &&
    getEnv('REACT_APP_OIDC_CONFIG_AUTO_SIGNIN') === 'true'
      ? true
      : false,
  automaticSilentRenew:
    getEnv('REACT_APP_OIDC_CONFIG_AUTOMATIC_SILENT_RENEW') &&
    getEnv('REACT_APP_OIDC_CONFIG_AUTOMATIC_SILENT_RENEW') === 'true'
      ? true
      : false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
}

const {
  authority,
  clientId,
  clientSecret,
  redirectUri,
  silentRedirectUri,
  postLogoutRedirectUri,
  responseType,
  scope,
  automaticSilentRenew,
  loadUserInfo,
  popupWindowFeatures,
  popupRedirectUri,
  popupWindowTarget,
  extraQueryParams,
  metadata,
  userStore,
} = oidcConfig

// Override userManager (coming from oidc-client) since that allows more options than the oidc-react config
oidcConfig.userManager = new UserManager({
  authority: authority || '',
  client_id: clientId || '',
  client_secret: clientSecret,
  redirect_uri: redirectUri || '',
  silent_redirect_uri: silentRedirectUri || '',
  post_logout_redirect_uri: postLogoutRedirectUri || '',
  response_type: responseType || 'code',
  scope: scope || 'openid',
  loadUserInfo: loadUserInfo !== undefined ? loadUserInfo : true,
  popupWindowFeatures: popupWindowFeatures,
  popup_redirect_uri: popupRedirectUri,
  popupWindowTarget: popupWindowTarget,
  automaticSilentRenew: automaticSilentRenew,
  extraQueryParams: extraQueryParams,
  metadata: metadata,
  userStore: userStore,
})

export default oidcConfig
